import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import App from "./App";
import LoginScreen from "./components/LoginScreen";
import { useAuth } from "./hooks/useAuth";
import WorkspacesHome from "./pages/WorkspacesHome";

export default function RootApp() {
  const {
    user,
    loading: authLoading,
    error: authError,
    login,
    register,
    logout,
  } = useAuth();

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 font-medium">
        Authenticating...
      </div>
    );
  }

  if (!user) {
    return <LoginScreen onLogin={login} onRegister={register} error={authError} />;
  }

  return (
    <Routes>
      <Route path="/" element={<WorkspacesHome user={user} />} />
      <Route
        path="/workspace/:workspaceId"
        element={<App user={user} logout={logout} />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
